import { Link } from 'react-router-dom';
import { QUICK_FILTERS } from '@yalidavet/shared';

export default function Footer() {
  return (
    <footer className="mt-24 border-t-2 border-gold-200 bg-gradient-to-b from-burgundy-900 via-burgundy-800 to-burgundy-950 text-cream-50">
      {/* Hairline separator */}
      <div className="flex justify-center py-8">
        <div className="h-px w-24 bg-gold-400/60" aria-hidden />
      </div>

      <div className="yd-container grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-4">
        {/* Brand */}
        <div className="space-y-4">
          <div className="flex items-center gap-3 group">
            <img
              src="/logo.jpeg"
              alt=""
              aria-hidden
              className="h-12 w-12 rounded-full object-cover ring-2 ring-gold-400/70 ring-offset-2 ring-offset-burgundy-900 transition-all duration-500 group-hover:ring-gold-300 group-hover:rotate-6"
            />
            <span className="font-display text-xl font-semibold tracking-[0.18em] uppercase text-white transition-colors group-hover:text-gold-300">Yalıda Davet</span>
          </div>
          <p className="text-sm text-cream-200 leading-relaxed">
            Özel yalılarda unutulmaz organizasyonlar. Düğünden doğum gününe, misafirperverliğin ruhunda her davet için doğru mekân.
          </p>
        </div>

        {/* Organizasyonlar */}
        <div>
          <h3 className="text-sm font-bold text-gold-300 uppercase tracking-wide">Organizasyonlar</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {QUICK_FILTERS.map((f) => (
              <li key={f.id}>
                <Link 
                  to={`/ara?eventTypeId=${f.id}`} 
                  className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block"
                >
                  → {f.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Ev Sahipleri */}
        <div>
          <h3 className="text-sm font-bold text-gold-300 uppercase tracking-wide">Ev Sahipleri</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/ilanlarim/yeni" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ Yeni İlan Oluştur</Link></li>
            <li><Link to="/ilanlarim" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ İlanlarım</Link></li>
            <li><a href="#" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ Ev Sahibi Rehberi</a></li>
            <li><a href="#" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ Gürültü Yönetmeliği</a></li>
          </ul>
        </div>

        {/* Destek */}
        <div>
          <h3 className="text-sm font-bold text-gold-300 uppercase tracking-wide">Destek</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a href="#" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ Yardım Merkezi</a></li>
            <li><a href="#" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ İptal & İade</a></li>
            <li><a href="#" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ Depozito Politikası</a></li>
            <li><a href="#" className="text-cream-200 hover:text-gold-300 transition-colors duration-200 hover:translate-x-1 inline-block">→ KVKK</a></li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gold-400/20" />

      {/* Copyright */}
      <div className="py-8">
        <p className="yd-container text-center text-xs text-cream-300/80 font-light tracking-wide">
          © {new Date().getFullYear()} Yalıda Davet. Tüm hakları saklıdır.
        </p>
      </div>
    </footer>
  );
}
